/**
 * ActorRuntimePage - Actor model runtime monitoring
 *
 * Surfaces the ActorRuntimeDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides visibility into actor mailboxes, message processing, and actor lifecycle.
 *
 * Route: /admin/actor-runtime
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconUsers } from '@tabler/icons-react';

import { ActorRuntimeDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function ActorRuntimePage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="indigo">
            <IconUsers size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Actor Runtime</Title>
            <Text size="sm" c="dimmed">
              Actor model runtime monitoring, mailbox queues, and message processing
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ActorRuntimeDashboard />
    </Container>
  );
}

export default ActorRuntimePage;
